@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ListDefault {
  @extend %font-family-primary;

  margin: 0 0 0 -1.25em;

  li::marker {
    font-size: $font-size-normal;
    font-weight: $font-weight-semibold;
    color: $theme-color-text;
  }
}

.ListDescription {
  @extend %font-family-primary;

  margin: 0 0 0 -1.25em;

  li::marker {
    font-size: $font-size-normal;
    font-weight: $font-weight-semibold;
    color: $theme-filter-icon-color;
  }
}
